import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'eddydata-lib';
import { AcaoGovernoShwComponent } from './acao-governo-shw/acao-governo-shw.component';
import { AcaoGovernoLstComponent } from './acao-governo-lst/acao-governo-lst.component';

const routes: Routes = [
  { path: '', component: AcaoGovernoLstComponent, canActivate: [AuthGuard] },
  { path: ':id/visualizar', component: AcaoGovernoShwComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AcaoGovernoRoutingModule { }
